// extracted by mini-css-extract-plugin
export var closeButton = "_q-5";
export var container = "_q-0";
export var contentContainer = "_q-1";
export var desktop = "_q-2";
export var fullModalImage = "_q-6";
export var mobile = "_q-3";
export var withImage = "_q-4";